import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
//import { getAppModule } from "./app/app.module";
/*import { FeatureModuleLoader } from "./feature-module-loader";*/

/*let fsLoader: FeatureModuleLoader = new FeatureModuleLoader("configs/feature.modules.json");
fsLoader.load().subscribe(modules => {
  platformBrowserDynamic().bootstrapModule(getAppModule(modules));
});*/
import { AppModule } from './app/app.module';
//import { environment } from './environments/environment';

/*if (environment.production) {
  enableProdMode();
}*/

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));



